import { Badge } from '@components/primitives/Badge.js'
import { formatCurrency, formatDate } from '@utils/format.js'
import type { DocItem } from './types.js'
import { formatBytes, getFileIcon } from './utils.js'

type Props = {
  doc: DocItem
  onEdit: () => void
  onDelete: () => void
  onPreview: () => void
}

function buildMetaLine(doc: DocItem): string {
  const parts: string[] = []
  if (doc.data) parts.push(formatDate(doc.data))
  if (doc.fornecedor) parts.push(doc.fornecedor)
  if (doc.tamanho != null && doc.tamanho > 0) parts.push(formatBytes(doc.tamanho))
  return parts.join(' · ')
}

export function DocumentoRow({ doc, onEdit, onDelete, onPreview }: Props) {
  const meta = buildMetaLine(doc)
  const nomeTitle = [doc.nome, doc.fornecedor, doc.categoria].filter(Boolean).join(' · ')
  const tipoLabel = getFileIcon(doc.tipo)

  return (
    <div className='cf3-doc-row' role='row' aria-label={`Documento: ${doc.nome}`}>
      <div className='cf3-doc-row__grid'>
        <div className='cf3-doc-row__line cf3-doc-row__line--title'>
          <button type='button' className='cf3-doc-row__nome' onClick={onPreview} title={nomeTitle}>
            {doc.nome}
          </button>
          <span className='cf3-doc-row__valor'>{formatCurrency(doc.valor ?? 0)}</span>
        </div>

        <div className='cf3-doc-row__line cf3-doc-row__line--foot'>
          <div className='cf3-doc-row__tags'>
            <Badge label={tipoLabel} variant='info' size='sm' />
            <span className='cf3-doc-row__badge-wrap' title={doc.categoria}>
              <Badge label={doc.categoria} size='sm' />
            </span>
          </div>
          {meta && (
            <span className='cf3-doc-row__meta' title={meta}>
              {meta}
            </span>
          )}
          <div className='cf3-doc-row__actions'>
            <button className='cf3-doc-row__btn' onClick={onEdit} aria-label={`Editar ${doc.nome}`}>
              Editar
            </button>
            <button
              className='cf3-doc-row__btn cf3-doc-row__btn--danger'
              onClick={onDelete}
              aria-label={`Excluir ${doc.nome}`}
            >
              Excluir
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
